import { makeStyles } from "@material-ui/core"
import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"
const useStyles = makeStyles({
	buttonPrimaryColorOutLined: {
		border: "1px solid",
		boxShadow: "none",
		borderColor: "rgba(126, 13, 214, 0.12)",
		fontWeight: 500,
		...ColorUtil.getBackgroundAndContrastColor("transparent"),
		color: colors.getPrimaryColor(),
		letterSpacing: 0.4,
		"&:hover": {
			...ColorUtil.getBackgroundAndContrastColor("transparent"),
			boxShadow: "none"
		}
	}
})

export default useStyles
